import { useState } from 'react';
import { AdmissionDeleteSoldItemsModal } from '@components/admission-delete-sold-items-modal';
import {
  ADMISSION_MODAL_STEP_ADMISSION_TYPE,
  ADMISSION_MODAL_STEP_BOTTLE_SERVICE,
  ADMISSION_MODAL_STEP_GUEST_LIST,
  ADMISSION_MODAL_STEP_TICKET,
  AdmissionModalStep,
} from '@components/admission-modal/admission-modal.type';
import { IconBottleService, IconGuestList, IconTicket } from '@components/icons';
import { ModalV2 } from '@components/modals';
import { AdmissionType } from '@domain/admission';
import {
  CreateAdmissionPresetRequest,
  PRESET_TYPE_BOTTLE_SERVICE,
  PRESET_TYPE_GUEST_LIST,
  PRESET_TYPE_TICKET,
  PresetType,
} from '@domain/preset';

import { CreatePreset as CreatePresetModal } from './create-preset';
import { Props } from './preset-modal.type';
import { PresetTypeModal } from './preset-type-modal';

type StepType = {
  [admissionType in PresetType]: AdmissionModalStep;
};

export const PresetModal = ({
  handleClose,
  handleSubmit,
  preset,
  floorplan,
  presetType,
  formFieldsPresets,
  isConfirmModalOpen,
  setActiveConfirmModal,
  handleCloseConfirmModal,
  handleSaveConfirmModal,
}: Props) => {
  const [isHideDeleteModalOpen, setIsHideDeleteModalOpen] = useState(false);

  const stepByType: StepType = {
    [PRESET_TYPE_BOTTLE_SERVICE]: ADMISSION_MODAL_STEP_BOTTLE_SERVICE,
    [PRESET_TYPE_GUEST_LIST]: ADMISSION_MODAL_STEP_GUEST_LIST,
    [PRESET_TYPE_TICKET]: ADMISSION_MODAL_STEP_TICKET,
  };

  const [step, setStep] = useState<AdmissionModalStep>(
    presetType ? stepByType[presetType] : ADMISSION_MODAL_STEP_ADMISSION_TYPE
  );

  const handleHideOffer = () => {
    setIsHideDeleteModalOpen(false);
  };

  const handleCloseHideDeleteModal = () => {
    setIsHideDeleteModalOpen(false);
  };

  return (
    <>
      {step === ADMISSION_MODAL_STEP_ADMISSION_TYPE && <PresetTypeModal handleClose={handleClose} setStep={setStep} />}

      {step === ADMISSION_MODAL_STEP_TICKET && (
        <CreatePresetModal
          handleClose={handleClose}
          handleSubmit={(currentPreset: CreateAdmissionPresetRequest, type: AdmissionType) => {
            handleSubmit(currentPreset, type);
          }}
          icon={IconTicket}
          iconClassName='bg-gray-200'
          formFieldsPresets={formFieldsPresets}
          type={PRESET_TYPE_TICKET}
          preset={preset}
          floorplan={floorplan}
          isConfirmModalOpen={isConfirmModalOpen}
          handleSaveConfirmModal={handleSaveConfirmModal}
          handleCloseConfirmModal={handleCloseConfirmModal}
          setActiveConfirmModal={setActiveConfirmModal}
        />
      )}

      {step === ADMISSION_MODAL_STEP_GUEST_LIST && (
        <CreatePresetModal
          handleClose={handleClose}
          handleSubmit={(currentPreset: CreateAdmissionPresetRequest, type: AdmissionType) => {
            handleSubmit(currentPreset, type);
          }}
          icon={IconGuestList}
          iconClassName='bg-gray-200'
          formFieldsPresets={formFieldsPresets}
          type={PRESET_TYPE_GUEST_LIST}
          preset={preset}
          floorplan={floorplan}
          isConfirmModalOpen={isConfirmModalOpen}
          handleSaveConfirmModal={handleSaveConfirmModal}
          handleCloseConfirmModal={handleCloseConfirmModal}
          setActiveConfirmModal={setActiveConfirmModal}
        />
      )}

      {step === ADMISSION_MODAL_STEP_BOTTLE_SERVICE && (
        <CreatePresetModal
          handleClose={handleClose}
          handleSubmit={(currentPreset: CreateAdmissionPresetRequest, type: AdmissionType) => {
            handleSubmit(currentPreset, type);
          }}
          icon={IconBottleService}
          iconClassName='bg-gray-200'
          formFieldsPresets={formFieldsPresets}
          type={PRESET_TYPE_BOTTLE_SERVICE}
          preset={preset}
          floorplan={floorplan}
          isConfirmModalOpen={isConfirmModalOpen}
          handleSaveConfirmModal={handleSaveConfirmModal}
          handleCloseConfirmModal={handleCloseConfirmModal}
          setActiveConfirmModal={setActiveConfirmModal}
        />
      )}

      <ModalV2 isOpen={isHideDeleteModalOpen} onClose={handleCloseHideDeleteModal} variant='sm'>
        <AdmissionDeleteSoldItemsModal handleClose={handleCloseHideDeleteModal} handleClick={handleHideOffer} />
      </ModalV2>
    </>
  );
};
